import { API_URLS } from '../config/api';
export async function loadArticleCovers(
  ids: string[],
  signal?: AbortSignal
): Promise<Record<string, string>> {
  const safeIds = [...new Set(ids.filter((id) => /^\d+$/.test(id)))];
  const covers: Record<string, string> = {};
  // Bounded metadata batches, not every image and prompt for every article.
  for (let offset = 0; offset < safeIds.length; offset += 20) {
    const batch = safeIds.slice(offset, offset + 20);
    const where = `(is_featured,eq,yes)~and((${batch.map((id) => `article_id,eq,${id}`).join(')~or(')}))`;
    const params = new URLSearchParams({
      where,
      fields: 'Id,article_id,image_url',
      limit: '100',
      sort: '-Id',
    });
    const response = await fetch(
      `${API_URLS.nocodb.tables('images')}?${params}`,
      { credentials: 'same-origin', signal }
    );
    if (!response.ok) throw new Error('Cover previews unavailable');
    const data = (await response.json()) as {
      list?: Array<{ article_id: string | number; image_url?: string }>;
    };
    for (const row of data.list ?? []) {
      const id = String(row.article_id);
      if (
        batch.includes(id) &&
        !covers[id] &&
        row.image_url?.startsWith('https://')
      )
        covers[id] = row.image_url;
    }
  }
  return covers;
}
